import React from "react";
import { useLocation } from "react-router-dom";
import { PfConfiguration } from "./PF";
import { EsiConfiguration } from "./ESI";
import { LwfConfiguration } from "./LWF";
import { PtConfiguration } from "./PT";

// Payroll > Configuration > Statutory: one page for every statutory item.
// The sidebar's Statutory group (PF, ESI, Professional Tax, Labour Welfare
// Fund) picks the item. The item and tab are in the address
// (?item=esi&tab=reason-codes) so other screens, e.g. Validation's fix
// buttons, can link straight to them. PT and LWF keep the open site in the
// address instead (?item=pt&site=2).

export const ConfigStatutoryConfiguration = () => {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const item = ["esi", "pt", "lwf"].includes(params.get("item")) ? params.get("item") : "pf";
  const tab = params.get("tab") || undefined;

  // key: a new item or tab in the address opens that screen fresh. PT / LWF are
  // keyed by item only, so going from a site back to the list keeps the
  // changes made this visit.
  if (item === "pt") return <PtConfiguration key="pt" />;
  if (item === "lwf") return <LwfConfiguration key="lwf" />;
  return item === "esi" ? <EsiConfiguration key={`esi:${tab}`} initialTab={tab} /> : <PfConfiguration key={`pf:${tab}`} initialTab={tab} />;
};
